import Picker from "react-mobile-picker-scroll";
import { ModalBottom } from "../ModalBottom";
import { useState } from "react";

interface Option {
  label: string;
  value: string;
}

interface ModalProps {
  data: Option[];
  title: string;
  onClose: () => void;
  onConfirm: (exCount: string) => void;
}

export const ModalExercisePicker = ({
  data,
  title,
  onClose,
  onConfirm,
}: ModalProps) => {
  const [selected, setSelected] = useState<string>(() => data[0].value);

  /* label => value 매핑 */
  const getValueByLabel = (label: string) =>
    data.find((d) => d.label === label)?.value ?? "";

  return (
    <>
      <ModalBottom title={title} onClose={onClose} onRow={true}>
        <>
          {/* 중앙 선택 Picker */}
          <div style={{ display: "flex", justifyContent: "center", gap: 8 }}>
            <Picker
              optionGroups={{ exOption: data.map((item) => item.label) }}
              valueGroups={{ exOption: selected }}
              onChange={(_: any, value: string) => setSelected(value)}
              itemHeight={48}
            />
          </div>

          {/* 확인 버튼 */}
          <div
            style={{
              height: 48,
              background: "#F57C00",
              borderRadius: 8,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              color: "white",
              fontWeight: 500,
              fontSize: 16,
            }}
            onClick={() => {
              const value = getValueByLabel(selected);
              onConfirm(value);
            }}
          >
            확인
          </div>
        </>
      </ModalBottom>
    </>
  );
};
